import { setupGtagConsent, setupUserCentrics } from '@ramp106/omrjs-core-ui/gtag'

const GTM_ID = 'GTM-W6ZRDWQ7'

export function bootstrapConsentAndTagManagers(): void {
  void setupGtagConsent(GTM_ID)
  setupUserCentrics()
}
